export const API_VERSION = process.env.API_VERSION ?? process.env.REACT_APP_DEFAULT_API_VERSION;

export const APP_HOST_URL = window.location.hostname === 'localhost' ? 'http://localhost:8080' : `https://${window.location.hostname}`;

export const APP_URL = APP_HOST_URL + `/api/${API_VERSION}`;

export const getRnd = () => {
    return Math.round(new Date().getTime() / 1000).toString();
}
